import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useTitleContentPropertiesForEditorQuery, {
	type useTitleContentPropertiesForEditorQuery$data,
	type useTitleContentPropertiesForEditorQuery$variables,
} from './__generated__/useTitleContentPropertiesForEditorQuery.graphql.ts';

export const preloadEditorPageTitleContentProperties = async ({
	contentId,
	draftShareId,
	useCache,
}: {
	contentId?: string | null;
	draftShareId: string;
	useCache: boolean;
}) => {
	const variables = {
		contentId,
		status: ['current', 'draft', 'archived'],
		draftShareId,
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	};
	return query<
		useTitleContentPropertiesForEditorQuery$data,
		useTitleContentPropertiesForEditorQuery$variables
	>({
		query: useTitleContentPropertiesForEditorQuery,
		variables,
	});
};
